import i18n from 'i18next';
import XHR from 'i18next-xhr-backend';
import { reactI18nextModule } from 'react-i18next';
import moment from 'moment';
import PackageJson from '../../../package.json';
import browserStorage from './browserStorage';

const init = (franchisor) => {
	const currentCulture = getCurrentCulture(franchisor);

	// init i18next
	i18n.changeLanguage(currentCulture, (error, t) => {
	});

	// localize moment
	moment.locale(currentCulture);
};

const getSelectedCulture = (franchisor) => {
	return browserStorage.getFromLocalStorage(franchisor, 'i18n_lng');
};

const getCurrentCulture = (franchisor) => {
	let currentCulture = getSelectedCulture(franchisor);
	if (!currentCulture) {
		currentCulture = 'en-GB';
	}
	return currentCulture;
};

const setCurrentCulture = (franchisor, lang) => {
	browserStorage.setToLocalStorage(franchisor, 'i18n_lng', lang);
	init(franchisor);
};

const setDefaultTimeZone = (timeZone) => {
	moment.tz.setDefault(timeZone);
}

export default {
	init,
	getSelectedCulture,
	getCurrentCulture,
	setCurrentCulture,
	setDefaultTimeZone
};

i18n
	.use(XHR)
	.use(reactI18nextModule)
	.init({
		whitelist: ['en', 'en-GB', 'bg-BG', 'de-DE', 'en-AU', 'cs-CZ', 'el-GR'], // Specify array of allowed languages
		fallbackLng: 'en',
		load: 'currentOnly', //to avoid warnings
		//lng: getCurrentCulture(),
		ns: ['frontofficeresources'],
		defaultNS: 'frontofficeresources',
		fallbackNS: 'frontofficeresources',	// fallback to 'resources' if default namespace is replaced with a custom namespace for the franchisor
		interpolation: {
			escapeValue: false, // not needed for react
			formatSeparator: ',',
			format: function (value, format, lng) {
				if (format === 'uppercase') return value.toUpperCase();
				return value;
			}
		},
		backend: {
			loadPath: (lng, ns) => {
				return `/locales/{{lng}}/{{ns}}.json?v=${PackageJson.version}`;
			}
		}
		//,debug: true		// use debug info for missing keys to generate replacement tags for <Trans> component
	});

export {
	i18n
};